export default __webpack_public_path__ + "static/media/instagram.e5ca533c.svg";